"use client";

import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { InteractionManager } from "@/lib/webgl/utils/interaction";

interface InteractionContextValue {
  manager: InteractionManager | null;
}

const InteractionContext = createContext<InteractionContextValue>({ manager: null });

interface InteractionProviderProps {
  children: React.ReactNode;
}

export const InteractionProvider: React.FC<InteractionProviderProps> = ({ children }) => {
  const managerRef = useRef<InteractionManager | null>(null);
  const [manager, setManager] = useState<InteractionManager | null>(null);

  useEffect(() => {
    // ドキュメント全体での座標・正規化座標を扱う
    const el = document.documentElement as HTMLElement;
    const mgr = new InteractionManager(el);
    managerRef.current = mgr;
    setManager(mgr);

    return () => {
      mgr.dispose();
      managerRef.current = null;
      setManager(null);
    };
  }, []);

  return (
    <InteractionContext.Provider value={{ manager }}>
      {children}
    </InteractionContext.Provider>
  );
};

export const useInteractionContext = (): InteractionContextValue => {
  return useContext(InteractionContext);
};

export default InteractionContext;


